module.exports = __webpack_public_path__ + "/images/shop/icon/catalog/spark_glow_ignition.svg";